import * as Immutable from 'seamless-immutable';

import {
  DOCUMENT_THUMBNAIL_URL_START,
  DOCUMENT_THUMBNAIL_URL_FULFILLED,
  CLEAR_ALL_THUMBNAILS,
} from '../actions';

const initialState = Immutable.from({
  list: {},
  isLoading: false,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case DOCUMENT_THUMBNAIL_URL_START:
      return state.merge({ isLoading: true });

    case DOCUMENT_THUMBNAIL_URL_FULFILLED: {
      const list = action.payload ? Object.assign({}, state.list, action.payload) : state.list;
      return state.merge({
        list,
        isLoading: false,
      });
    }

    case CLEAR_ALL_THUMBNAILS:
      return Immutable.from(initialState);

    default:
      return state;
  }
};
